import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { andComp, orComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { ValidatedDateSetting } from '@bingads-webui-campaign-react/date-setting';

import { DateSettingSkeleton } from '../components/skeletons';

const entityIsAdGroup = entityIs(ERROR_ENTITY.AdGroup);
const adGroupDateSettingsProp = andComp(entityIsAdGroup, orComp(propertyIs('StartDate'), propertyIs('EndDate')));

const ServerValidatedDateSetting = withControlErrorHandling(withUnvalidatedControlErrors(ValidatedDateSetting, { filter: adGroupDateSettingsProp }));

export const DateSettingCard = ({ data, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  const {
    StartDate,
    EndDate,
    adGroupStatus,
    campaignTimeZone,
  } = data || {};

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Start and end dates'))}
      />
      <FormCardBody>
        {data ? (
          <ServerValidatedDateSetting
            validateOnLoad
            validationProps={{
              data: {
                StartDate,
                EndDate,
                TimeZone: campaignTimeZone,
                status: adGroupStatus,
              },
            }}
            label={i18n.getString(_TL_('When do you want your ads to run?'))}
          />
        ) : (
          <DateSettingSkeleton />
        )}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

DateSettingCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
